<template>
    <v-container>
        <v-container class="text-overline text-center">{{ $langs.CreateStore.createStore[$langs.lang] }}</v-container>

        <v-row>
            <v-col cols="12" md="6">
                <v-form
                    ref="form"
                    v-model="valid"
                    :lazy-validation="lazy"
                    @submit.prevent="submit()"
                >
                    <!-- Store name -->
                    <v-text-field
                        v-model="storeName"
                        :label="$langs.MyStore.storeName[$langs.lang]"
                        :counter="30"
                        :rules="nameRules"
                        required
                    ></v-text-field>

                    <!-- Store name -->
                    <v-autocomplete
                        v-model="address.province"
                        :items="PROVINCES"
                        item-text="province"
                        item-value="province"
                        :label="`${$langs.MyStore.storeLocation[$langs.lang]} (จังหวัด)`"
                        hide-no-data
                        :rules="[(v) => !!v || 'required']"
                    ></v-autocomplete>

                    <!-- Select Bank -->
                    <v-select
                        v-model="bank"
                        :label="$langs.CreateStore.pleaseChooseYourBank[$langs.lang]"
                        :items="banks"
                        :rules="[v => !!v || 'required']"
                        required
                    ></v-select>

                    <!-- Bank Account Number -->
                    <v-text-field
                        v-model="bankID"
                        :label="$langs.CreateStore.bankAccountNumber[$langs.lang]"
                        :rules="bankRules"
                        required
                    ></v-text-field>

                    <!-- Id card Image -->
                    <v-file-input
                        accept="image/*"
                        :label="$langs.CreateStore.uploadIdentityCard[$langs.lang]"
                        prepend-icon="mdi-camera"
                        @change="f => onFilesSelected(f, 0)"
                        :rules="[v => !!v || 'required']"
                        required
                    ></v-file-input>
                    <!-- @change="onFilesSelected" -->

                    <!-- Bankbook Image -->
                    <v-file-input
                        accept="image/*"
                        :label="$langs.CreateStore.uploadBookbankImage[$langs.lang]"
                        prepend-icon="mdi-camera"
                        @change="f => onFilesSelected(f, 1)"
                        :rules="[v => !!v || 'required']"
                        required
                    ></v-file-input>

                    <!-- Agree checkbox -->
                    <v-checkbox
                        v-model="checkbox"
                        :label="$langs.CreateStore.agreeWithTerms[$langs.lang]"
                        :rules="[v => !!v || 'You must agree to continue!']"
                        class="mb-3"
                        required
                    ></v-checkbox>

                    <v-btn
                        :disabled="!valid"
                        color="primary"
                        class="mr-4"
                        type="submit"
                        :loading="isLoading"
                    >{{ $langs.CreateStore.createStore[$langs.lang] }}</v-btn>

                    <v-btn class="mr-4" @click="cancel()">{{ $langs.Gen.cancel[$langs.lang] }}</v-btn>
                </v-form>
            </v-col>

            <v-col md="6">
                <!-- Agreement and Condition -->
                <div class="text-subtitle-1">
                    เงื่อนไขการให้บริการจัดตั้งร้านค้า
                    <ol class="text-caption">
                        <li>ผู้ขายยินยอมให้ Marketpettใช้ข้อมูลของสินค้า (รูป, รายละเอียด และราคาสินค้า) ที่ร้านค้าอัพเดตบน Facebook หรือ Instagram และทำการผลักดันสินค้าของร้านค้าผ่านเข้าแคมเปญต่างๆ เพื่อให้เกิดยอดขาย ในกรณีที่เบอร์โทรศัพท์ของผู้ขายได้มีการลงทะเบียนเป็นบัญชีผู้ขายหรือผู้ซื้อของ Marketpett อยู่ก่อนแล้ว</li>
                        <li>
                            ผู้ขายให้สิทธิ Marketpettในการเข้าถึงบัญชีของผู้ขาย และ ข้อมูลอื่นใดในแพลตฟอร์มของ Marketpett(ยกเว้นข้อมูลส่วนการเงินของร้านค้า) และดำเนินการใดๆ ที่จำเป็นเพื่อวัตถุประสงค์ในการให้บริการ Shop Set-up ให้แก่ผู้ขาย โดยมีรูปแบบและขอบเขตการให้บริการ มีดังนี้
                            <ul>
                                <li>เปิดบัญชีหน้าร้าน และอัพโหลดสินค้า</li>
                                <li>อัพเดทสต็อก จัดการออเดอร์ และ แจ้งเตือนร้านค้าเมื่อมีออเดอร์</li>
                                <li>บริการอื่นใดที่ได้ตกลงร่วมกัน</li>
                            </ul>
                        </li>
                        <li>Marketpett ขอสงวนสิทธิ์ที่จะเปลี่ยนแปลงข้อกำหนดและเงื่อนไขของการให้บริการจัดตั้งร้านค้า (Shop Set-up Service) ทั้งหมดตามที่เห็นสมควรโดยไม่ต้องมีการแจ้งล่วงหน้า</li>
                        <li>ห้ามขายสินค้าที่ผิดกฏหมาย / สัตว์ที่ต้องขอใบอนุญาติครอบครอง / สัตว์ป่าคุ้มครองและสัตว์สงวน หากพบเห็นจะทำการแบนร้านค้าในทันทีโดยไม่ต้องแจ้งให้ทราบ</li>
                        <li>เว๊ปไซต์นี้อยู่ระหว่างการพัฒนา หากเจอปัญหาในการใช้งานสามารถแจ้งได้ที่<br/> Facebook Page: Marketpett, Email: contact.marketpett@gmail.com</li>
                    </ol>
                </div>

                <div class="mt-8 text-center red--text text--darken-1">แนบไฟล์รูปตามตัวอย่างนี้</div>
                <v-row class="mt-2 justify-center">
                    <div class="d-inline-block px-3">
                        <div class="text-center mb-2">ID Card (Example)</div>
                        <v-img width="200" class="mx-auto" contain src="@/assets/img/6a45efb2a6a52393.png"></v-img>
                    </div>      
                    <div class="d-inline-block px-3">
                        <div class="text-center mb-2">BookBank (Example)</div>
                        <v-img width="200" class="mx-auto" src="@/assets/img/BookBank.png"></v-img>
                    </div>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
// import store from "@/services/store";
import { compressImages } from "../../services/constants.js";
import store from "../../services/store";
import api from "../../services/api";

export default {
    data() {
        return {
            isLoading: false,
            valid: true,
            lazy: false,
            storeName: "",
            bankID: "",
            bank: null,
            IDCardImage: null,
            bankImage: null,
            address: {
                province: "",
            },
            checkbox: false,
            nameRules: [
                v => !!v || "Store Name is required",
                v =>
                    (v && v.length <= 30) ||
                    "Store Name must be less than 30 characters"
            ],
            bankRules: [
                v => !!v || "Bank account is required",
                v => {
                    v = v.replace(/-/g, "");
                    return /^\d+$/.test(v) || "Bank account is not valid";
                },
                v => {
                    v = v.replace(/-/g, "");
                    return (
                        (v && v.length <= 12) ||
                        "Bank account must be 10-12 characters"
                    );
                }
            ],
            banks: [
                { text: "Siam Commercial Bank", value: "scb" },
                { text: "Kasikorn Thai Bank", value: "kbank" },
                { text: "Bangkok Bank", value: "bbl" },
                { text: "Krung Thai Bank", value: "ktb" },
                { text: "Krungsri Bank", value: "bay" },
                { text: "Thanachart Bank", value: "tbank" },
                { text: "TMB Bank", value: "tmb" },
                { text: "Government Savings Bank", value: "gsb" }
            ],
            PROVINCES: require("@/assets/data/provinces.json"),
        };
    },
    methods: {
        async onFilesSelected(file, from) {
            if (!file) return;
            // from: 0 = IDCard, 1 = BookBank
            if (from == 0) this.IDCardImage = "";
            else this.bankImage = "";

            let comFile = (await compressImages([file]))[0];
            if (from == 0) this.IDCardImage = comFile;
            else this.bankImage = comFile;
        },
        async submit() {
            if (!this.$refs.form.validate()) return;
            this.isLoading = true;

            while (this.IDCardImage == "" || this.bankImage == "")
                await new Promise(r => setTimeout(r, 50));

            let formData = new FormData();
            formData.append("storeName", this.storeName);
            formData.append("bank", this.bank);
            formData.append("bankID", this.bankID.replace(/-/g, ""));
            formData.append("IDCardImage", this.IDCardImage);
            formData.append("bankImage", this.bankImage);
            formData.append("address", JSON.stringify(this.address));

            let { success, msg } = await store.createStore(formData);
            if (success) {
                api.makeAlert("Create Store successfully.", "primary");
                await this.$store.dispatch('RefreshUser');
                await new Promise(r => setTimeout(r, 1000));
                this.$router.push("/mystore");
            } else {
                api.makeAlert(msg, "error");
            }
            this.isLoading = false;
        },
        cancel() {
            // this.$refs.form.reset()
            this.$router.go(-1);
        }
    },
    watch: {
        bankID(value) {
            value = value.replace(/-/g, "");
            if (/(\d{3})(\d{1})(\d{5})(\d{1})/.test(value)) {
                this.bankID = value.replace(
                    /(\d{3})(\d{1})(\d{5})(\d{1})/,
                    "$1-$2-$3-$4"
                );
            } else if (/(\d{3})(\d{1})(\d{1,5})/.test(value)) {
                // scb, kbank, bbl, ktb
                this.bankID = value.replace(
                    /(\d{3})(\d{1})(\d{1,5})/,
                    "$1-$2-$3"
                );
            } else if (/(\d{3})(\d{1})/.test(value)) {
                this.bankID = value.replace(/(\d{3})(\d{1})/, "$1-$2");
            }
        }
    }
};
</script>

<style>
</style>
